import {
  CatalogProductDetailViewFragmentFragment,
  CatalogVariantFragmentFragment,
} from '@notino/shared/definitions/types';

export const getProductName = (
  variant: CatalogVariantFragmentFragment,
  product: CatalogProductDetailViewFragmentFragment
): string => {
  const variantDescription =
    variant.attributes && variant.attributes.Master
      ? product.annotation
      : variant.variantName;

  return `${product.brand?.name ?? ''} ${product.collection ?? ''} ${
    variantDescription ?? ''
  }`;
};
export const findDescriptionWithoutStrong = (html: string): string => {
  if (!html) {
    return '';
  }

  const pTagRegex = /<p[^>]*>(.*?)<\/p>/gi;
  let match;

  while ((match = pTagRegex.exec(html)) !== null) {
    const content = match[1];
    if (!/<strong[^>]*>.*?<\/strong>/i.test(content)) {
      return content;
    }
  }

  return '';
};
